import { Link } from 'gatsby';
import clsx from 'clsx';
import React, { FC, useState, useEffect } from 'react';
import { Container, Nav, Navbar as BNavbar, Button } from 'react-bootstrap';
import Logo from '../Logo';
import NavItem from '../NavItem';
import * as styles from './Navbar.module.scss';

const NAVBAR_HEIGHT = 61;

const Navbar: FC = () => {
  const [active, setActive] = useState(false);

  const navbarCx = clsx({
    [styles.navbar]: true,
    'active': active,
  });

  useEffect(() => {
    setActive(window.pageYOffset > NAVBAR_HEIGHT);

    const listener = () => {
      const isScrolledOver = window.pageYOffset > NAVBAR_HEIGHT;
      setActive(isScrolledOver);
    };
    
    window.addEventListener('scroll', listener);

    return () => window.removeEventListener('scroll', listener);
  }, []);

  return (
    <BNavbar className={navbarCx} expand="lg" fixed="top">
      <Container>
        <Link to="/">
          <Logo/>
        </Link>
        
        <BNavbar.Toggle aria-controls="basic-navbar-nav" />

        <BNavbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto m">
            <NavItem path="/projects">
              Projects
            </NavItem>
            <NavItem path="/about">
              About
            </NavItem>
            <Link to="/contact" className={styles.navbarAction}>
              <Button>Contact</Button>
            </Link>
          </Nav>
        </BNavbar.Collapse>
      </Container>
    </BNavbar>
  );
};

export default Navbar;
